import React from 'react';
import OwlCarousel from 'react-owl-carousel2';
import {Button} from '../components/Button/index';
import apiSettings from '../config/api';
import appConst from '../config/const';

const owlOptions = {
  items: 4,
  nav: true,
  dots: false,
  rewind: true,
  autoplay: true,
  autoplayHoverPause: true,
  margin: 20,
};

const defaultImg = () => {
  const result = [];
  for (let i = 0; i < 5; i++) {
    result.push(
      <div className="create-tour__photos-item" key={`create-preview-img-block-${i}`}>
        <i
          className="fa fa-picture-o"
          aria-hidden="true"
        />
      </div>
    )
  }
  return (
    <OwlCarousel options={owlOptions} key="owl-1">
      {result}
    </OwlCarousel>
  );
};


const createPreviewImages = (images, deleteImage) => {
  const createSrcPath = (img) => {
    let src = '/assets/img/noimage.png';
    if (img && img.preview) {
      src = img.preview;
    }
    if (img && img[appConst.PHOTOS.small] && img.updatedAt) {
      src = apiSettings.endpoints.genImageUrl(img[appConst.PHOTOS.small], img.updatedAt);
    }
    return src;
  };
  const result = [];
  for (let i = 0; i < images.length; i++) {
    result.push(
      <div
        className="create-tour__photos-item"
        key={`create-preview-img-block-${images[i].id || i + 1}`}
      >
        <Button
          className="button__icon ion-close-round"
          name="Delete"
          onClick={() => deleteImage(images[i].id || i)}
        />
        <img
          src={createSrcPath(images[i])}
          alt="text"
        />
      </div>
    )
  }

  if (result.length >= 4) {
    owlOptions.responsive = {
      320: {
        items: 1
      },
      400: {
        items: 2
      },
      660: {
        items: 3
      },
      980: {
        items: 4
      }
    };
  }
  return (
    <OwlCarousel options={owlOptions} key="owl-1">
      {result}
    </OwlCarousel>
  );
};


export {defaultImg, createPreviewImages}


// WEBPACK FOOTER //
// ./src/app/utils/tourImages.js